<app-header *ngIf="showHeaderFooter" ></app-header>

<div *ngIf="isModalOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full text-center space-y-6">
    <h2 class="text-lg font-semibold">Are you a fan or a student?</h2>

    <div class="flex flex-col space-y-3">
      <a href="{{this.loadeddata['loginFan']}}"
         class="w-full btn-primary text-white py-2 rounded transition text-center">
        Fan Sign In
      </a>
      <a href="{{this.loadeddata['loginStudent']}}"
         class="w-full btn-primary text-white py-2 rounded transition text-center">
        Student Sign In
      </a>
      <a href="{{this.loadeddata['loginFaculty']}}"
         class="w-full btn-primary text-white py-2 rounded transition text-center">
        Faculty Sign In
      </a>
    </div>

    <button (click)="closeModal()" class="text-sm text-gray-500 hover:underline mt-2">
      Close
    </button>
  </div>
</div>

<main *ngIf="showHeaderFooter"  class="min-h-screen mt-[72px] ">
  <router-outlet></router-outlet>
</main>

<main *ngIf="!showHeaderFooter">
  <router-outlet></router-outlet>
</main>

<app-footer *ngIf="showHeaderFooter"></app-footer>
